import get from 'lodash/get';
import { gql, graphql, compose } from 'react-apollo';

import { identify } from 'util/logger';

const userQuery = gql`
  query {
    user {
      id
      name
    }
  }
`;

export default WrappedComponent => {
  return compose(
    graphql(userQuery, {
      options: { fetchPolicy: 'network-only' },
      props: ({ data }) => {
        const userId = get(data, 'user.id');

        if (userId) {
          identify(data.user);
        }

        return {
          isLoggedIn: Boolean(userId && localStorage.getItem('auth0IdToken')),
          currentUserId: userId,
          currentUserName: get(data, 'user.name'),
        };
      },
    })
  )(WrappedComponent);
};



// WEBPACK FOOTER //
// ./src/common/hoc/withAuth.js